import * as yup from 'yup';

export const loginSchema = yup.object().shape({
  identifier: yup
    .string()
    .required('Brukernavn eller e-post er påkrevd')
    .min(3, 'Må være minst 3 tegn'),
  password: yup
    .string()
    .required('Passord er påkrevd')
    .min(8, 'Passord må være minst 8 tegn'),
});

export const registerSchema = yup.object().shape({
  firstName: yup
    .string()
    .required('Fornavn er påkrevd')
    .min(2, 'Fornavn må være minst 2 tegn')
    .max(50, 'Fornavn må være mindre enn 50 tegn'),
  lastName: yup
    .string()
    .required('Etternavn er påkrevd')
    .min(2, 'Etternavn må være minst 2 tegn')
    .max(50, 'Etternavn må være mindre enn 50 tegn'),
  password: yup
    .string()
    .required('Passord er påkrevd')
    .min(8, 'Passord må være minst 8 tegn')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
      'Passord må inneholde minst én stor bokstav, én liten bokstav, ett tall og ett spesialtegn'
    ),
  confirmPassword: yup
    .string()
    .required('Bekreft passordet ditt')
    .oneOf([yup.ref('password')], 'Passordene må være like'),
  email: yup
    .string()
    .required('E-post er påkrevd')
    .email('Skriv inn en gyldig e-postadresse'),
  phone: yup
    .string()
    .required('Telefonnummer er påkrevd')
    .min(8, 'Telefonnummer må være minst 8 tegn')
    .max(15, 'Telefonnummer må være mindre enn 15 tegn')
    .matches(/^[\d\s\+\-\(\)]+$/, 'Telefonnummer kan kun inneholde tall, mellomrom og tegn: + - ( )'),
  role: yup
    .string()
    .required('Rolle er påkrevd')
    .oneOf(['admin', 'sales', 'manager', 'user'], 'Ugyldig rolle valgt'),
  department: yup
    .string()
    .required('Avdeling er påkrevd')
    .oneOf(['sales', 'marketing', 'editorial', 'admin', 'management'], 'Ugyldig avdeling valgt'),
  newspaper: yup
    .string()
    .required('Avis er påkrevd')
    .min(2, 'Avisnavnet må være minst 2 tegn')
    .max(100, 'Avisnavnet må være mindre enn 100 tegn'),
});